import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=946c0f7c"
import script from "./goTop.vue?vue&type=script&lang=js"
export * from "./goTop.vue?vue&type=script&lang=js"
import style0 from "./goTop.vue?vue&type=style&index=0&id=946c0f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports